import {
  FETCH_CREATED_VS_RESOLVED,
  FETCH_CREATED_VS_RESOLVED_SUCCESS,
  FETCH_CREATED_VS_RESOLVED_FAIL,
  FETCH_CREATED_WORK_ORDERS,
  FETCH_CREATED_WORK_ORDERS_SUCCESS,
  FETCH_CREATED_WORK_ORDERS_FAIL,
  FETCH_RESOLVED_WORK_ORDERS,
  FETCH_RESOLVED_WORK_ORDERS_SUCCESS,
  FETCH_RESOLVED_WORK_ORDERS_FAIL,
  SET_REPORT_DATE_RANGE,
  CLEAR_WORK_ORDER_LIST,
  FETCH_WORK_ORDERS_BY_TYPE,
  FETCH_WORK_ORDERS_BY_TYPE_SUCCESS,
  FETCH_WORK_ORDERS_BY_TYPE_FAIL,
  FETCH_WORK_ORDERS_BY_TYPE_LIST,
  FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS,
  FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL,
  FETCH_REPEATING_REPORT,
  FETCH_REPEATING_REPORT_SUCCESS,
  FETCH_REPEATING_REPORT_FAIL,
  FETCH_REPEATING_REPORT_LIST,
  FETCH_REPEATING_REPORT_LIST_SUCCESS,
  FETCH_REPEATING_REPORT_LIST_FAIL,
  FETCH_STATUS_REPORT,
  FETCH_STATUS_REPORT_SUCCESS,
  FETCH_STATUS_REPORT_FAIL,
  FETCH_STATUS_REPORT_LIST,
  FETCH_STATUS_REPORT_LIST_SUCCESS,
  FETCH_STATUS_REPORT_LIST_FAIL,
  FETCH_PRIORITY_REPORT,
  FETCH_PRIORITY_REPORT_SUCCESS,
  FETCH_PRIORITY_REPORT_FAIL,
  FETCH_PRIORITY_REPORT_LIST,
  FETCH_PRIORITY_REPORT_LIST_SUCCESS,
  FETCH_PRIORITY_REPORT_LIST_FAIL,
  FETCH_TIME_TO_COMPLETE,
  FETCH_TIME_TO_COMPLETE_SUCCESS,
  FETCH_TIME_TO_COMPLETE_FAIL,
  FETCH_COMPLETED_WORK_ORDERS,
  FETCH_COMPLETED_WORK_ORDERS_SUCCESS,
  FETCH_COMPLETED_WORK_ORDERS_FAIL,
  FETCH_MTTR_WORK_ORDERS,
  FETCH_MTTR_WORK_ORDERS_SUCCESS,
  FETCH_MTTR_WORK_ORDERS_FAIL,
  FETCH_ON_TIME_OVERDUE,
  FETCH_ON_TIME_OVERDUE_SUCCESS,
  FETCH_ON_TIME_OVERDUE_FAIL,
  FETCH_ON_TIME_OVERDUE_LIST,
  FETCH_ON_TIME_OVERDUE_LIST_SUCCESS,
  FETCH_ON_TIME_OVERDUE_LIST_FAIL,
  FETCH_COMPLETED_BY_USER,
  FETCH_COMPLETED_BY_USER_SUCCESS,
  FETCH_COMPLETED_BY_USER_FAIL,
  FETCH_COMPLETED_BY_USER_LIST,
  FETCH_COMPLETED_BY_USER_LIST_SUCCESS,
  FETCH_COMPLETED_BY_USER_LIST_FAIL,
  FETCH_STATUS_DURATION_REPORT,
  FETCH_STATUS_DURATION_REPORT_SUCCESS,
  FETCH_STATUS_DURATION_REPORT_FAIL,
  FETCH_ASSET_PERFORMANCE,
  FETCH_ASSET_PERFORMANCE_SUCCESS,
  FETCH_ASSET_PERFORMANCE_FAIL,
  FETCH_RECENT_ACTIVITY,
  FETCH_RECENT_ACTIVITY_SUCCESS,
  FETCH_RECENT_ACTIVITY_FAIL,
  FETCH_RECENT_ACTIVITY_MORE,
  FETCH_RECENT_ACTIVITY_MORE_SUCCESS,
  FETCH_RECENT_ACTIVITY_MORE_FAIL,
  SET_RECENT_ACTIVITY_FILTERS,
  CLEAR_RECENT_ACTIVITY,
  FETCH_CURRENT_STATUS,
  FETCH_CURRENT_STATUS_SUCCESS,
  FETCH_CURRENT_STATUS_FAIL,
  FETCH_MOST_PROBLEMATIC,
  FETCH_MOST_PROBLEMATIC_SUCCESS,
  FETCH_MOST_PROBLEMATIC_FAIL,
  FETCH_DOWNTIME_BREAKDOWN,
  FETCH_DOWNTIME_BREAKDOWN_SUCCESS,
  FETCH_DOWNTIME_BREAKDOWN_FAIL,
  FETCH_TOTAL_DOWNTIME,
  FETCH_TOTAL_DOWNTIME_SUCCESS,
  FETCH_TOTAL_DOWNTIME_FAIL,
  FETCH_DOWNTIME_COST,
  FETCH_DOWNTIME_COST_SUCCESS,
  FETCH_DOWNTIME_COST_FAIL,
  FETCH_WORK_ORDER_COST_REPORT,
  FETCH_WORK_ORDER_COST_REPORT_SUCCESS,
  FETCH_WORK_ORDER_COST_REPORT_FAIL,
  FETCH_MAINTENANCE_SPEND_BY_ASSET,
  FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS,
  FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL,
  EXPORT_CSV,
  EXPORT_CSV_SUCCESS,
  EXPORT_CSV_FAIL,
  CLEAR_EXPORT_STATE,
} from './actionTypes';

// Default to last 30 days
const getDefaultDateRange = () => {
  const endDate = new Date();
  endDate.setHours(23, 59, 59, 999);
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 30);
  startDate.setHours(0, 0, 0, 0);
  return {
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
  };
};

const INIT_STATE = {
  // Created vs Resolved Report
  createdVsResolved: null,
  createdVsResolvedLoading: false,
  createdVsResolvedError: null,

  // Work Order List (for modal)
  workOrderList: null,
  workOrderListLoading: false,
  workOrderListError: null,

  // Date Range
  dateRange: getDefaultDateRange(),

  // Work Orders by Type Report
  workOrdersByType: null,
  workOrdersByTypeLoading: false,
  workOrdersByTypeError: null,

  // Repeating Report
  repeatingReport: null,
  repeatingReportLoading: false,
  repeatingReportError: null,

  // Status Report
  statusReport: null,
  statusReportLoading: false,
  statusReportError: null,

  // Priority Report
  priorityReport: null,
  priorityReportLoading: false,
  priorityReportError: null,

  // Time to Complete Report
  timeToComplete: null,
  timeToCompleteLoading: false,
  timeToCompleteError: null,

  // On Time vs Overdue Report
  onTimeOverdue: null,
  onTimeOverdueLoading: false,
  onTimeOverdueError: null,

  // Completed by User Report
  completedByUser: null,
  completedByUserLoading: false,
  completedByUserError: null,

  // Status Duration Report
  statusDurationReport: null,
  statusDurationReportLoading: false,
  statusDurationReportError: null,

  // Asset Performance Report
  assetPerformance: null,
  assetPerformanceLoading: false,
  assetPerformanceError: null,

  // Asset Health: Current Status
  currentStatus: null,
  currentStatusLoading: false,
  currentStatusError: null,

  // Asset Health: Most Problematic Assets
  mostProblematic: null,
  mostProblematicLoading: false,
  mostProblematicError: null,

  // Asset Health: Downtime Breakdown
  downtimeBreakdown: null,
  downtimeBreakdownLoading: false,
  downtimeBreakdownError: null,

  // Asset Health: Total Downtime
  totalDowntime: null,
  totalDowntimeLoading: false,
  totalDowntimeError: null,
  downtimeCost: null,
  downtimeCostLoading: false,
  downtimeCostError: null,

  // Work Order Cost Report (labor / parts / contractor)
  workOrderCostReport: null,
  workOrderCostReportLoading: false,
  workOrderCostReportError: null,

  // Asset Health: Maintenance Spend by Asset
  maintenanceSpendByAsset: null,
  maintenanceSpendByAssetLoading: false,
  maintenanceSpendByAssetError: null,

  // CSV Export
  exportLoading: false,
  exportError: null,
  exportSuccess: false,

  // Recent Activity Report
  recentActivity: null,
  recentActivityLoading: false,
  recentActivityLoadingMore: false,
  recentActivityError: null,
  recentActivityFilters: {
    assignedTo: null,
    locationId: null,
    priority: null,
    dueDateStart: null,
    dueDateEnd: null,
  },
};

const Reporting = (state = INIT_STATE, action) => {
  switch (action.type) {
    // Created vs Resolved Report
    case FETCH_CREATED_VS_RESOLVED:
      return {
        ...state,
        createdVsResolvedLoading: true,
        createdVsResolvedError: null,
      };

    case FETCH_CREATED_VS_RESOLVED_SUCCESS:
      return {
        ...state,
        createdVsResolved: action.payload,
        createdVsResolvedLoading: false,
        createdVsResolvedError: null,
      };

    case FETCH_CREATED_VS_RESOLVED_FAIL:
      return {
        ...state,
        createdVsResolved: null,
        createdVsResolvedLoading: false,
        createdVsResolvedError: action.payload,
      };

    // Created Work Orders
    case FETCH_CREATED_WORK_ORDERS:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_CREATED_WORK_ORDERS_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_CREATED_WORK_ORDERS_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Resolved Work Orders
    case FETCH_RESOLVED_WORK_ORDERS:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_RESOLVED_WORK_ORDERS_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_RESOLVED_WORK_ORDERS_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Date Range
    case SET_REPORT_DATE_RANGE:
      return {
        ...state,
        dateRange: {
          startDate: action.payload.startDate,
          endDate: action.payload.endDate,
        },
      };

    // Clear Work Order List
    case CLEAR_WORK_ORDER_LIST:
      return {
        ...state,
        workOrderList: null,
        workOrderListError: null,
      };

    // Work Orders by Type Report
    case FETCH_WORK_ORDERS_BY_TYPE:
      return {
        ...state,
        workOrdersByTypeLoading: true,
        workOrdersByTypeError: null,
      };

    case FETCH_WORK_ORDERS_BY_TYPE_SUCCESS:
      return {
        ...state,
        workOrdersByType: action.payload,
        workOrdersByTypeLoading: false,
        workOrdersByTypeError: null,
      };

    case FETCH_WORK_ORDERS_BY_TYPE_FAIL:
      return {
        ...state,
        workOrdersByType: null,
        workOrdersByTypeLoading: false,
        workOrdersByTypeError: action.payload,
      };

    // Work Orders by Type List
    case FETCH_WORK_ORDERS_BY_TYPE_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_WORK_ORDERS_BY_TYPE_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_WORK_ORDERS_BY_TYPE_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Repeating Report
    case FETCH_REPEATING_REPORT:
      return {
        ...state,
        repeatingReportLoading: true,
        repeatingReportError: null,
      };

    case FETCH_REPEATING_REPORT_SUCCESS:
      return {
        ...state,
        repeatingReport: action.payload,
        repeatingReportLoading: false,
        repeatingReportError: null,
      };

    case FETCH_REPEATING_REPORT_FAIL:
      return {
        ...state,
        repeatingReport: null,
        repeatingReportLoading: false,
        repeatingReportError: action.payload,
      };

    // Repeating Report List
    case FETCH_REPEATING_REPORT_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_REPEATING_REPORT_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_REPEATING_REPORT_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Status Report
    case FETCH_STATUS_REPORT:
      return {
        ...state,
        statusReportLoading: true,
        statusReportError: null,
      };

    case FETCH_STATUS_REPORT_SUCCESS:
      return {
        ...state,
        statusReport: action.payload,
        statusReportLoading: false,
        statusReportError: null,
      };

    case FETCH_STATUS_REPORT_FAIL:
      return {
        ...state,
        statusReport: null,
        statusReportLoading: false,
        statusReportError: action.payload,
      };

    // Status Report List
    case FETCH_STATUS_REPORT_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_STATUS_REPORT_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_STATUS_REPORT_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Priority Report
    case FETCH_PRIORITY_REPORT:
      return {
        ...state,
        priorityReportLoading: true,
        priorityReportError: null,
      };

    case FETCH_PRIORITY_REPORT_SUCCESS:
      return {
        ...state,
        priorityReport: action.payload,
        priorityReportLoading: false,
        priorityReportError: null,
      };

    case FETCH_PRIORITY_REPORT_FAIL:
      return {
        ...state,
        priorityReport: null,
        priorityReportLoading: false,
        priorityReportError: action.payload,
      };

    // Priority Report List
    case FETCH_PRIORITY_REPORT_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_PRIORITY_REPORT_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_PRIORITY_REPORT_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Time to Complete Report
    case FETCH_TIME_TO_COMPLETE:
      return {
        ...state,
        timeToCompleteLoading: true,
        timeToCompleteError: null,
      };

    case FETCH_TIME_TO_COMPLETE_SUCCESS:
      return {
        ...state,
        timeToComplete: action.payload,
        timeToCompleteLoading: false,
        timeToCompleteError: null,
      };

    case FETCH_TIME_TO_COMPLETE_FAIL:
      return {
        ...state,
        timeToComplete: null,
        timeToCompleteLoading: false,
        timeToCompleteError: action.payload,
      };

    // Completed Work Orders List (Time to Complete drill-down)
    case FETCH_COMPLETED_WORK_ORDERS:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_COMPLETED_WORK_ORDERS_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_COMPLETED_WORK_ORDERS_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // MTTR Work Orders List
    case FETCH_MTTR_WORK_ORDERS:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_MTTR_WORK_ORDERS_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_MTTR_WORK_ORDERS_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // On Time vs Overdue Report
    case FETCH_ON_TIME_OVERDUE:
      return {
        ...state,
        onTimeOverdueLoading: true,
        onTimeOverdueError: null,
      };

    case FETCH_ON_TIME_OVERDUE_SUCCESS:
      return {
        ...state,
        onTimeOverdue: action.payload,
        onTimeOverdueLoading: false,
        onTimeOverdueError: null,
      };

    case FETCH_ON_TIME_OVERDUE_FAIL:
      return {
        ...state,
        onTimeOverdue: null,
        onTimeOverdueLoading: false,
        onTimeOverdueError: action.payload,
      };

    // On Time vs Overdue List
    case FETCH_ON_TIME_OVERDUE_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_ON_TIME_OVERDUE_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_ON_TIME_OVERDUE_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Completed by User Report
    case FETCH_COMPLETED_BY_USER:
      return {
        ...state,
        completedByUserLoading: true,
        completedByUserError: null,
      };

    case FETCH_COMPLETED_BY_USER_SUCCESS:
      return {
        ...state,
        completedByUser: action.payload,
        completedByUserLoading: false,
        completedByUserError: null,
      };

    case FETCH_COMPLETED_BY_USER_FAIL:
      return {
        ...state,
        completedByUser: null,
        completedByUserLoading: false,
        completedByUserError: action.payload,
      };

    // Completed by User List
    case FETCH_COMPLETED_BY_USER_LIST:
      return {
        ...state,
        workOrderListLoading: true,
        workOrderListError: null,
      };

    case FETCH_COMPLETED_BY_USER_LIST_SUCCESS:
      return {
        ...state,
        workOrderList: action.payload,
        workOrderListLoading: false,
        workOrderListError: null,
      };

    case FETCH_COMPLETED_BY_USER_LIST_FAIL:
      return {
        ...state,
        workOrderList: null,
        workOrderListLoading: false,
        workOrderListError: action.payload,
      };

    // Status Duration Report
    case FETCH_STATUS_DURATION_REPORT:
      return {
        ...state,
        statusDurationReportLoading: true,
        statusDurationReportError: null,
      };

    case FETCH_STATUS_DURATION_REPORT_SUCCESS:
      return {
        ...state,
        statusDurationReport: action.payload,
        statusDurationReportLoading: false,
        statusDurationReportError: null,
      };

    case FETCH_STATUS_DURATION_REPORT_FAIL:
      return {
        ...state,
        statusDurationReport: null,
        statusDurationReportLoading: false,
        statusDurationReportError: action.payload,
      };

    // Asset Performance Report
    case FETCH_ASSET_PERFORMANCE:
      return {
        ...state,
        assetPerformanceLoading: true,
        assetPerformanceError: null,
      };

    case FETCH_ASSET_PERFORMANCE_SUCCESS:
      return {
        ...state,
        assetPerformance: action.payload,
        assetPerformanceLoading: false,
        assetPerformanceError: null,
      };

    case FETCH_ASSET_PERFORMANCE_FAIL:
      return {
        ...state,
        assetPerformance: null,
        assetPerformanceLoading: false,
        assetPerformanceError: action.payload,
      };

    // Recent Activity Report
    case FETCH_RECENT_ACTIVITY:
      return {
        ...state,
        recentActivityLoading: true,
        recentActivityError: null,
      };

    case FETCH_RECENT_ACTIVITY_SUCCESS:
      return {
        ...state,
        recentActivity: action.payload,
        recentActivityLoading: false,
        recentActivityError: null,
      };

    case FETCH_RECENT_ACTIVITY_FAIL:
      return {
        ...state,
        recentActivity: null,
        recentActivityLoading: false,
        recentActivityError: action.payload,
      };

    // Recent Activity Load More
    case FETCH_RECENT_ACTIVITY_MORE:
      return {
        ...state,
        recentActivityLoadingMore: true,
      };

    case FETCH_RECENT_ACTIVITY_MORE_SUCCESS:
      return {
        ...state,
        recentActivity: state.recentActivity ? {
          ...action.payload,
          groups: [...(state.recentActivity.groups || []), ...(action.payload.groups || [])],
        } : action.payload,
        recentActivityLoadingMore: false,
      };

    case FETCH_RECENT_ACTIVITY_MORE_FAIL:
      return {
        ...state,
        recentActivityLoadingMore: false,
        recentActivityError: action.payload,
      };

    // Recent Activity Filters
    case SET_RECENT_ACTIVITY_FILTERS:
      return {
        ...state,
        recentActivityFilters: {
          ...state.recentActivityFilters,
          ...action.payload,
        },
      };

    case CLEAR_RECENT_ACTIVITY:
      return {
        ...state,
        recentActivity: null,
        recentActivityError: null,
      };

    // CSV Export
    case EXPORT_CSV:
      return {
        ...state,
        exportLoading: true,
        exportError: null,
        exportSuccess: false,
      };

    case EXPORT_CSV_SUCCESS:
      return {
        ...state,
        exportLoading: false,
        exportError: null,
        exportSuccess: true,
      };

    case EXPORT_CSV_FAIL:
      return {
        ...state,
        exportLoading: false,
        exportError: action.payload,
        exportSuccess: false,
      };

    case CLEAR_EXPORT_STATE:
      return {
        ...state,
        exportLoading: false,
        exportError: null,
        exportSuccess: false,
      };

    // Asset Health: Current Status
    case FETCH_CURRENT_STATUS:
      return {
        ...state,
        currentStatusLoading: true,
        currentStatusError: null,
      };
    case FETCH_CURRENT_STATUS_SUCCESS:
      return {
        ...state,
        currentStatus: action.payload,
        currentStatusLoading: false,
        currentStatusError: null,
      };
    case FETCH_CURRENT_STATUS_FAIL:
      return {
        ...state,
        currentStatusLoading: false,
        currentStatusError: action.payload,
      };

    // Asset Health: Most Problematic Assets
    case FETCH_MOST_PROBLEMATIC:
      return {
        ...state,
        mostProblematicLoading: true,
        mostProblematicError: null,
      };
    case FETCH_MOST_PROBLEMATIC_SUCCESS:
      return {
        ...state,
        mostProblematic: action.payload,
        mostProblematicLoading: false,
        mostProblematicError: null,
      };
    case FETCH_MOST_PROBLEMATIC_FAIL:
      return {
        ...state,
        mostProblematic: null,
        mostProblematicLoading: false,
        mostProblematicError: action.payload,
      };

    // Asset Health: Downtime Breakdown
    case FETCH_DOWNTIME_BREAKDOWN:
      return {
        ...state,
        downtimeBreakdownLoading: true,
        downtimeBreakdownError: null,
      };
    case FETCH_DOWNTIME_BREAKDOWN_SUCCESS:
      return {
        ...state,
        downtimeBreakdown: action.payload,
        downtimeBreakdownLoading: false,
        downtimeBreakdownError: null,
      };
    case FETCH_DOWNTIME_BREAKDOWN_FAIL:
      return {
        ...state,
        downtimeBreakdown: null,
        downtimeBreakdownLoading: false,
        downtimeBreakdownError: action.payload,
      };

    // Asset Health: Total Downtime
    case FETCH_TOTAL_DOWNTIME:
      return {
        ...state,
        totalDowntimeLoading: true,
        totalDowntimeError: null,
      };
    case FETCH_TOTAL_DOWNTIME_SUCCESS:
      return {
        ...state,
        totalDowntime: action.payload,
        totalDowntimeLoading: false,
        totalDowntimeError: null,
      };
    case FETCH_TOTAL_DOWNTIME_FAIL:
      return {
        ...state,
        totalDowntime: null,
        totalDowntimeLoading: false,
        totalDowntimeError: action.payload,
      };

    // Asset Health: Downtime Cost
    case FETCH_DOWNTIME_COST:
      return {
        ...state,
        downtimeCostLoading: true,
        downtimeCostError: null,
      };
    case FETCH_DOWNTIME_COST_SUCCESS:
      return {
        ...state,
        downtimeCost: action.payload,
        downtimeCostLoading: false,
        downtimeCostError: null,
      };
    case FETCH_DOWNTIME_COST_FAIL:
      return {
        ...state,
        downtimeCost: null,
        downtimeCostLoading: false,
        downtimeCostError: action.payload,
      };

    // Work Order Cost Report
    case FETCH_WORK_ORDER_COST_REPORT:
      return {
        ...state,
        workOrderCostReportLoading: true,
        workOrderCostReportError: null,
      };
    case FETCH_WORK_ORDER_COST_REPORT_SUCCESS:
      return {
        ...state,
        workOrderCostReport: action.payload,
        workOrderCostReportLoading: false,
        workOrderCostReportError: null,
      };
    case FETCH_WORK_ORDER_COST_REPORT_FAIL:
      return {
        ...state,
        workOrderCostReport: null,
        workOrderCostReportLoading: false,
        workOrderCostReportError: action.payload,
      };

    // Asset Health: Maintenance Spend by Asset
    case FETCH_MAINTENANCE_SPEND_BY_ASSET:
      return {
        ...state,
        maintenanceSpendByAssetLoading: true,
        maintenanceSpendByAssetError: null,
      };
    case FETCH_MAINTENANCE_SPEND_BY_ASSET_SUCCESS:
      return {
        ...state,
        maintenanceSpendByAsset: action.payload,
        maintenanceSpendByAssetLoading: false,
        maintenanceSpendByAssetError: null,
      };
    case FETCH_MAINTENANCE_SPEND_BY_ASSET_FAIL:
      return {
        ...state,
        maintenanceSpendByAsset: null,
        maintenanceSpendByAssetLoading: false,
        maintenanceSpendByAssetError: action.payload,
      };

    default:
      return state;
  }
};

export default Reporting;
